export default __webpack_public_path__ + "static/media/convenioCard.3f7eb57c.svg";